"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/ListControl/ListControl");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
let obj = {
    matches: ["listControl"],
    execute: (commandName, commandOptions, $container) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        $container.synListControl({
            titleProperty: commandOptions.titleProperty,
            detailsProperties: commandOptions.detailProperties,
            methods: commandOptions.menuEntries
        });
        let fieldNames = [commandOptions.titleProperty].concat(commandOptions.detailProperties);
        yield $container.synListControl("setDataAsync", Utilities_1.synUtil.searchAsync(commandOptions.typeId, commandOptions.searchInstance, fieldNames));
    }),
    isBreadcrumbElement: true
};
exports.default = obj;
